//common
import useMsgServer from '@/domain/common/msg.server.js';
import useInteractiveServer from '@/domain/media/interactive.server.js';
import useMediaCheckServer from '@/domain/media/mediaCheck.server.js';
import useMediaSettingServer from '@/domain/media/mediaSetting.server.js';
import useMediaStaticMicrophoneServer from '@/domain/media/mediaStaticMicrophone.server.js';
import usePlayerServer from '@/domain/player/player.server.js';
import useDocServer from '@/domain/doc/doc.server.js';
import useCanvasStreamServer from '@/domain/media/canvasStream.server.js';

import useRoomBaseServer from '@/domain/room/roombase.server.js';
import useUserServer from '@/domain/user/userServer.js';
import useVirtualAudienceServer from '@/domain/audience/virtualAudience.server.js';
import useInsertFileServer from '@/domain/media/insertFile.server.js';

import useDesktopShareServer from '@/domain/media/desktopShare.server.js';
import useChatServer from '@/domain/chat/chat.server.js';
import useMicServer from '@/domain/media/mic.server.js';
import useNoticeServer from '@/domain/notice/notice.server.js';
import useMemberServer from '@/domain/member/member.server.js';
import useGroupServer from '@/domain/group/StandardGroupServer';
import useTimerServer from '@/domain/interactiveTools/timer.server.js';
import useGiftsServer from '@/domain/interactiveTools/gift.server.js';
import useWatchRewardServer from '@/domain/interactiveTools/reward.server.js';
import useWatchGiftServer from '@/domain/interactiveTools/watchGift.server.js';
import useCashRedpacketServer from '@/domain/interactiveTools/cashRedpacket.server';
import useAttentionServer from '@/domain/interactiveTools/attention.server.js';
import usePraiseServer from '@/domain/interactiveTools/praise.server.js';
import usePendantServer from '@/domain/interactiveTools/pendant.server.js';
import useSignServer from '@/domain/interactiveTools/sign.server.js';
import useSignUpFormServer from '@/domain/interactiveTools/signUpForm.server.js';
import useKeyLoginServer from '@/domain/keyLogin/keyLogin.server.js';

import useCustomMenuServer from '@/domain/brand/customMenu.server';

import useRebroadcastServer from '@/domain/interactiveTools/rebroadcast.server';
import useZIndexServer from '@/domain/interactiveTools/zindexServer.js';

// 问答关联
import useQaAdminServer from '@/domain/interactiveTools/qaadmin.server.js';
import useQaServer from '@/domain/interactiveTools/qa.server.js';
import { setRequestBody, setRequestHeaders } from '@/utils/http.js';
import FullLinkReport from '@/utils/fullLink.report.js'
import VhallPaasSDK, { allSdkConfig } from '../sdk';
import { Dep } from '@/domain/common/base.server';
import { INIT_DOMAIN } from '@/domain/common/dep.const';
import useChatAuthServer from './chat/chatAuth.server';

import useCashServer from '@/domain/cash/cash.server.js';
// 商品
import useGoodServer from '@/domain/interactiveTools/good.server.js';
import useLotteryServer from '@/domain/interactiveTools/lotteryServer.js';
import useInteractRewardServer from '@/domain/interactiveTools/interactReward.server.js';
import useQuestionnaireServer from '@/domain/interactiveTools/questionnaireServer.js';
import usePrivacyAgreementServer from '@/domain/interactiveTools/privacyAgreement.server.js';

import useMenuServer from '@/domain/brand/menu.server';
import useInviteServer from '@/domain/interactiveTools/invite.server.js';
import useFeedbackServer from '@/domain/interactiveTools/feedback.server.js';
import useEntryformServer from '@/domain/entryform/entry.server.js';
import useSubscribeServer from '@/domain/subscribe/subscribe.server';
import useSubjectServer from '@/domain/brand/subject.server';
import useCodeRedPacketServer from '@/domain/interactiveTools/redCodePacketServer.js';

//观看端下载
import useFileDownloadServer from './interactiveTools/fileDoanload.server';

import useSplitScreenServer from '@/domain/media/splitScreen.server';
import useVideoPollingServer from '@/domain/media/videoPolling.server';

import useHomepageServer from '@/domain/brand/homepage.server';

import useRecommendServer from '@/domain/brand/recommend.server'
import useExamServer from '@/domain/interactiveTools/exam.server.js';

// ai创作服务
import useAiServer from '@/domain/brand/ai.server.js';
//回放列表服务
import usePlaybackServer from '@/domain/brand/playbackServer.js';

import useMallRewardServer from '@/domain/interactiveTools/mallReward.server';
import to from 'await-to-js';

/**
 * options:{
    token,
    liveToken,
    plugins:['chat', 'player', 'doc', 'interaction']
  }
 */
class Domain {
  constructor(options) {
    if (options.requestHeaders) {
      if (options.requestHeaders.token == 'undefined') {
        options.requestHeaders.token = ''
      }
      // 如果初始化存在 clientType，domain 会自动将 clientType 添加到请求头
      if (options.initRoom?.clientType) {
        setRequestHeaders({
          ...options.requestHeaders,
          'client-type': options.initRoom.clientType
        });
      } else {
        setRequestHeaders(options.requestHeaders);
      }
    }
    if (options.requestBody) {
      setRequestBody(options.requestBody);
    }

    let taskList = options.isNotInitPass ? [] : [this.initPassSdk(options)];
    // 是否在创建domain实例的时候初始化房间
    if (!options.isNotInitRoom) {
      taskList.push(this.initRoom(options.initRoom))
    }
    return Promise.all(taskList).then(res => {
      return this;
    })
  }


  //初始化房间信息
  async initRoom(roomInitOptions) {
    const roomBaseServer = useRoomBaseServer();
    if (['standard'].includes(roomInitOptions.clientType)) {
      // 标准直播观看端： 初始化直播信息 + 获取公众号引流配置信息
      return Promise.all([
        roomBaseServer.initLive(roomInitOptions),
        roomBaseServer.initWechatOaConfig(roomInitOptions.webinar_id)
      ]).then(async (values) => {
        const res1 = values[0];
        if (res1.code != 200) {
          return Promise.reject(res1);
        }
        const res2 = values[1];
        // 公众号引流配置信息获取成功 + 满足相关环境条件
        if (res2.code == 200 && roomBaseServer.wechatOaFollowEnvCheck()) {
          await to(Promise.allSettled([
            // 获取公众二维码链接
            roomBaseServer.getWechatOaQrcodeUrl(roomInitOptions.webinar_id),
            // 获取当前用户是否关注了公众号的状态
            roomBaseServer.wechatOaHasSubscribed({
              openid: sessionStorage.getItem('open_id'), //待查询人的openid
              business_uid: sessionStorage.getItem('initGrayId') // 待查询B端租户Id
            })
          ]))
          if (roomBaseServer.state.wechatOaConfig?.follow_type == 2 && !roomBaseServer.state.wechatOaConfig?.existed) {
            // 开启了强制关注，但是没有关注公众号，
            roomBaseServer.state.watchInitData.status = 'subscribe'
          }
        }
        return Promise.resolve(res1);
      })
    } else {
      return roomBaseServer.initLive(roomInitOptions);
    }
  }
  initPassSdk(options) {
    const sdkList = VhallPaasSDK.init(options.plugins, options.questionnaireNoDefer);
    return Promise.all(sdkList).then(res => {
      //触发所有注册的依赖passsdk和房间初始化的回调
      // Dep.expenseDep(INIT_DOMAIN, res);
      for (const item of Object.values(allSdkConfig)) {
        if (item.name && window[item.name]) {
          VhallPaasSDK.modules[item.name] = window[item.name];
        }
      }
      // vhallLog 放到 domain 中初始化，domain
      if (options.devLogOptions) {
        this.initVhallLog(options.devLogOptions)
      }
    })
  }
  // 初始化【开发侧】日志上报
  initVhallLog(devLogOptions) {
    window.vhallLog = window.ITextbookLog(devLogOptions)
  }

  // 初始化数据上报, 【客户】需要的统计数据
  initVhallReport(reportOptions) {
    window.vhallReport = new VhallReport(reportOptions);
  }
  //数据中心埋点初始化
  initVhallDataAgent(dataOptions) {
    window.VhallDataAgent?.init(dataOptions)
  }
  //设置数据中心埋点公参
  setVHDataCommonOptions(options) {
    //先清除公参
    window.VhallDataAgent?.clearSuperProperties()
    window.VhallDataAgent?.registerSuperProperty(options)
  }

  // 微吼直播【产品侧】需要的数据(观看端,接入数据信息平台,与发起端区分)
  initVhallReportForWatch(reportOptions) {
    window.vhallReportForWatch = new VhallReportForProduct(reportOptions);
  }

  // 微吼直播【产品侧】需要的数据
  initVhallReportForProduct(reportOptions) {
    window.vhallReportForProduct = new VhallReportForProduct(reportOptions);

    // 链路埋点实例化
    const fullLinkReport = new FullLinkReport({
      reportOptions: reportOptions,
      useRoomBaseServer: useRoomBaseServer,
      reportCallback: rId => {
        // rId && setRequestHeaders({
        //   'request-id': rId
        // })
      }
    });
    window.vhallReportForProduct.toReport = fullLinkReport.report.bind(fullLinkReport);
    window.vhallReportForProduct.toStartReporting = fullLinkReport.startReporting.bind(fullLinkReport)
    window.vhallReportForProduct.toResultsReporting = fullLinkReport.resultsReporting.bind(fullLinkReport)

  }

}
const version = '__VERSION__';

export {
  Domain,
  useMsgServer,
  useRoomBaseServer,
  useUserServer,
  usePlayerServer,
  useVirtualAudienceServer,
  // useRoomInitGroupServer,
  useInteractiveServer,
  useCanvasStreamServer,
  useMediaCheckServer,
  useMediaSettingServer,
  useMediaStaticMicrophoneServer,
  useInsertFileServer,
  useDesktopShareServer,
  useChatServer,
  useChatAuthServer,
  useMicServer,
  useDocServer,
  useNoticeServer,
  useMemberServer,
  useGroupServer,
  useQaAdminServer,
  useQaServer,
  useCustomMenuServer,
  useRebroadcastServer,
  useTimerServer,
  useGiftsServer,
  useWatchRewardServer,
  useWatchGiftServer,
  useCashRedpacketServer,
  useCashServer,
  useAttentionServer,
  useGoodServer,
  usePraiseServer,
  usePendantServer,
  useLotteryServer,
  useInteractRewardServer,
  usePrivacyAgreementServer,
  useSignServer,
  useMenuServer,
  useQuestionnaireServer,
  useInviteServer,
  useFeedbackServer,
  version,
  useEntryformServer,
  useSignUpFormServer,
  useSubscribeServer,
  useSubjectServer,
  useCodeRedPacketServer,
  useKeyLoginServer,
  useSplitScreenServer,
  useVideoPollingServer,
  useHomepageServer,
  useRecommendServer,
  useZIndexServer,
  useExamServer,
  useFileDownloadServer,
  useAiServer,
  usePlaybackServer,
  useMallRewardServer
};
